// extracted by mini-css-extract-plugin
module.exports = {"folder":"nav_folders_content-module__folder--2eUUN"};